module.exports = __webpack_public_path__ + "img/bottom-btn-inactive.2d7d0a68.png";